<template>
  <div>
    <a-page-header
      style="border: 1px solid rgb(235, 237, 240)"
      :title="$t('service.policy')"
      sub-title=""
      @back="back()"
    />
    <div class="inner">
      <a-card
        style="width: 80%"
        :tab-list="tabList"
        :active-tab-key="currentType"
        @tabChange="(key) => onTabChange(key, 'currentType')"
      >
        <a-typography-title v-if="currentType == '0'" :level="3">{{
          title0
        }}</a-typography-title>
        <a-list
          v-if="currentType == '0'"
          item-layout="vertical"
          size="large"
          :data-source="listData0"
          :loading="listLoading0"
        >
          <template #renderItem="{ item }">
            <a-list-item key="item.title">
              <a-list-item-meta :description="item.description">
                <template #title>
                  <a>{{ item.title }}</a>
                </template>
                <template #avatar><a-avatar :src="item.avatar" /></template>
              </a-list-item-meta>
              <pre class="artticle">{{ item.content }}</pre>
            </a-list-item>
          </template>
        </a-list>

        <a-typography-title v-if="currentType == '1'" :level="3">{{
          title1
        }}</a-typography-title>
        <a-list
          v-if="currentType == '1'"
          item-layout="vertical"
          size="large"
          :data-source="listData1"
          :loading="listLoading1"
        >
          <template #renderItem="{ item }">
            <a-list-item key="item.title">
              <a-list-item-meta :description="item.description">
                <template #title>
                  <a>{{ item.title }}</a>
                </template>
                <template #avatar><a-avatar :src="item.avatar" /></template>
              </a-list-item-meta>
              <pre class="artticle">{{ item.content }}</pre>
            </a-list-item>
          </template>
        </a-list>
      </a-card>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { message } from "ant-design-vue";
import { useI18n } from "vue-i18n";
import axios from "axios";

let router = useRouter();

/**选中类型 */
const currentType = ref("0");
/**卡片加载状态 */
const loading = ref(false);
/**卡片上方选项卡配置 */
const tabList = [
  {
    key: "0",
    tab: "激光切割机",
  },
  {
    key: "1",
    tab: "手持焊",
  },
];
/**激光切割机标题 */
const title0 = ref();
/**激光切割机时间 */
const time0 = ref();
/**激光切割机列表数据 */
const listData0 = ref([]);
/**激光切割机列表加载状态 */
const listLoading0 = ref(false);

/**手持焊标题 */
const title1 = ref();
/**手持焊时间 */
const time1 = ref();
/**手持焊列表数据 */
const listData1 = ref([]);
/**手持焊列表加载状态 */
const listLoading1 = ref(false);

/**
 * 主函数入口
 */
init();

async function init() {
  /**获取保修政策数据 */
  await loadData(currentType.value)
    .then((data) => {
      handleData(data);
    })
    .catch((error) => {
      message.error(error.toString());
    });
}

/**处理获取后的数据 */
function handleData(data) {
  let type = Number(currentType.value);

  let listDataArr = [listData0, listData1];
  let titleArr = [title0, title1];

  if (Array.isArray(data)) {
    if (data.length == 0) {
      return;
    }
    listDataArr[type].value = [];
    titleArr[type].value = data[0].Title;
    listDataArr[type].value.push(
      {
        title: "保修范围",
        content: data[0].WarrantyScope,
      },
      {
        title: "不保修范围",
        content: data[0].NotWarrantyScope,
      },
      {
        title: "服务流程",
        content: data[0].ServiceProcess,
      }
    );
  }
}

/**获取保修政策 */
function loadData(type) {
  type = type.toString();
  let loadArr = [listLoading0, listLoading1];
  loadArr[Number(type)].value = true;

  return new Promise((resolve, reject) => {
    axios
      .post("api/WarrantyRule/GetList", {
        Id: "",
        MachineType: type, //设备种类（0：激光切割机1：手持焊）
      })
      .then(function (response) {
        loadArr[Number(type)].value = false;
        if (response.data.code != 200) {
          reject(response.data.info);
        } else {
          resolve(response.data.ReturnData);
        }
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

/**卡片点击选项卡切换 */
async function onTabChange(value, type) {
  currentType.value = value;

  await loadData(currentType.value)
    .then((data) => {
      handleData(data);
    })
    .catch((error) => {
      message.error(error.toString());
    });
}

/**返回上一页 */
function back() {
  history.back();
}
</script>

<style scoped>
.inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}
.artticle {
  width: 100%;
  border: none;
  padding: 0px;
  background-color: white;
  font-family: Menlo, Monaco, Consolas, -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
a {
  line-height: 32px;
}
</style>
